import { csx } from '@vtex/admin-ui'

const styles = {
  couponsSection: csx({
    rowGap: '$space-2',
    alignItems: 'flex-start',
    flexDirection: 'column',
  }),
  spinner: csx({ marginLeft: '0.5rem' }),
  cursorOnDisabled: csx({
    '[disabled]': {
      cursor: 'not-allowed',
    },
  }),
}

export default styles
